// extracted by mini-css-extract-plugin
export var avatar = "_ic-3";
export var avatarContainer = "_ic-2";
export var avatarSpacer = "_ic-5";
export var avatarSpacerContainer = "_ic-4";
export var avatarStackContainer = "_ic-1";
export var bubble = "_ic-0";
export var remainderBubble = "_ic-6";